module.exports = __webpack_public_path__ + "assets/img/menu-bg.2516eb79.png";